import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import useLocale from 'js/hooks/useLocale'
import { languages, translatedLanguageNames, language } from '../../locale'

const LanguageSwitcher = props => {
  const { language: currentLanguage, setLanguage } = useLocale()
  const listRef = useRef()
  const [menuOpen, setMenuOpen] = useState(false)

  const documentClickListener = e => {
    if (!listRef.current || !listRef.current.contains(e.target)) {
      setMenuOpen(false)
    }
  }

  useEffect(() => {
    if (menuOpen) {
      document.addEventListener('click', documentClickListener)
    }

    return () => {
      document.removeEventListener('click', documentClickListener)
    }
  }, [menuOpen])

  const toggleList = () => {
    setMenuOpen(!menuOpen)
  }

  return (
    <div
      className={classNames('c-language-switcher', {
        'c-language-switcher--inverted': props.inverted,
        'c-language-switcher--desktop': props.desktop,
      })}
    >
      <button
        className={classNames('c-language-switcher__button', {
          'c-language-switcher__button--open': menuOpen,
          'c-menu-bar__link': props.desktop,
        })}
        onClick={toggleList}
        aria-controls="locale-dropdown"
        data-testid="language-list-toggler"
        data-uid="language-list-toggler"
        type="button"
      >
        {props.desktop && (
          <span className="c-menu-bar__link-text">
            <span className="visually-hidden">Language: </span>
            {currentLanguage}
          </span>
        )}
        {!props.desktop && (
          <>
            <span className="visually-hidden">Language: </span>
            {currentLanguage}
          </>
        )}
      </button>
      {menuOpen && (
        <div
          className={classNames('c-language-switcher__list', {
            'c-language-switcher__list--open': menuOpen,
          })}
          id="locale-dropdown"
          ref={listRef}
        >
          <ul>
            {languages.map(code => (
              <li
                key={code}
                className="c-language-switcher__item"
                lang={code}
                data-testid="language-list"
              >
                <a
                  className={classNames('c-language-switcher__link', {
                    'c-language-switcher__link--active':
                      currentLanguage === code,
                  })}
                  href={code === language.ENGLISH ? '/' : `/${code}`}
                  onClick={e => {
                    e.preventDefault()
                    setLanguage(code, props.redirect)
                    props.onLanguageChange && props.onLanguageChange(code)
                    setMenuOpen(false)
                  }}
                  data-uid="language-list-toggler-language"
                >
                  <span>{translatedLanguageNames[code]}</span>
                </a>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  )
}

LanguageSwitcher.propTypes = {
  inverted: PropTypes.bool,
  desktop: PropTypes.bool,
  onLanguageChange: PropTypes.func,
  redirect: PropTypes.bool,
}

export default LanguageSwitcher
